import React from 'react';

const Print = ({ size, content, title }) => {
  const stylesHtml = `
  html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}@page{margin:0}body{font-family: "monospace" !important;margin:0}.sheet{margin:0;overflow:hidden;position:relative;box-sizing:border-box;page-break-after:always}body.LABEL .sheet{width:50mm;height:30mm}body.LABEL.landscape .sheet{width:30mm;height:50mm}body.A4 .sheet{width:210mm;height:279mm}body.A4.landscape .sheet{width:297mm;height:209mm}@media screen{body{background:#e0e0e0}.sheet{background:#fff;box-shadow:0 .5mm 2mm rgba(0,0,0,.3);margin:5mm}.bg-section{-webkit-print-color-adjust:exact}}@media print{body.LABEL{width:50mm}body.A3.landscape{width:420mm}body.A3,body.A4.landscape{width:297mm}body.A4,body.A5.landscape{width:210mm}body.A5{width:148mm}.bg-section{-webkit-print-color-adjust:exact}}@media print{.page-break{page-break-after:always}.bg-section{-webkit-print-color-adjust:exact}@page{padding-right:10px}}body{font-size:90%}table{width:100%;}table th,table td{font-family: monospace; font-weight: normal !important;}h2,h3,h4{padding:0;margin:0}p{font-size:80%;word-wrap:break-word}.border-top{border-top:1px solid #000}.border-left{border-left:1px solid #000}.border-right{border-right:1px solid #000}.border-bottom{border-bottom:1px solid #000}.bordered{border:1px solid #000!important}table.body th{border-bottom:1px solid #000;padding:10px 0;text-align:left}table.body td.p{padding:15px 10px}table.header{width:100%}td.center,th.center{text-align:center}td.right,th.right{text-align:right!important}th.center{text-align:center!important}.footer{position:absolute;bottom:0;right:0;margin-top:auto;text-align:right}

  `;

  const render = () => {
    document.write(
      `<!DOCTYPE html><html><head><style>${stylesHtml}</style><link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter:wght@100;400;600;700;900&display=swap" rel="stylesheet"><title>${title}</title></head><body class="${size}">${content}</body></html>`
    );
  };

  React.useEffect(() => {
    render();

    setTimeout(function () {
      window.focus();
      window.print();

      setTimeout(function () {
        window.close();
      }, 100);
    }, 500);
  }, []);

  return null;
};

export default Print;
